export default function Numpy_Intro() {
  return <div>Numpy_Intro Component</div>;
}
